import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import SDKIntegrationsHelper from '../../../Utility/SDK/SDKIntegrationsHelper';
import { BoosterType } from '../../Card/BoosterType';
import CardStateHelper from '../../Card/CardStateHelper';
import { HelperFriendActions } from './HelperFriendActions';
import { helpFriend } from './HelperFriendStateHelper';
import { track, TrackMethod } from '../../../Utility/Tracking/Track';
import { ContextType, ResponseType, ResponseStatus } from '../../Game/ContextType';
import { IGameState } from '../../Game/IGameState';
import ContextStateHelper from 'State/Game/Context/ContextStateHelper';

export const HelperFriendReducer: Reducer<IGameState> = (
    state: IGameState,
    action: ActionType<typeof HelperFriendActions>
): IGameState => {
    switch (action.type) {
        case getType(HelperFriendActions.helperFriendRequest):
            SDKIntegrationsHelper.helperFriendRequest(action.payload);

            state = {
                ...state,
                levelState: {
                    ...state.levelState,
                    cardsState: {
                        ...state.levelState.cardsState,
                        tasks: [],
                    },
                },
            };

            // Use set context to pause game/audio and return.
            // This is not necessarily done via common GameAction.setContext action due to increasing complexity
            // and level-tasks not being cleared -- since GameActions.setContext returns before the LevelReducer
            // is run.
            return ContextStateHelper.setContext(state, ContextType.REQUEST_HELP, {});
        case getType(HelperFriendActions.helperFriendResponse):
            state = ContextStateHelper.restoreContext(state, {
                responseType: ResponseType.REQUEST_HELP,
                status: action.payload.success ? ResponseStatus.SUCCESS : ResponseStatus.FAIL,
            });

            if (action.payload.success) {
                state = CardStateHelper.playBooster(state, BoosterType.PLUS_THREE);
                state = helpFriend(state, action.payload.friendId);

                track('mFriendHelped', 1);
                track('mFriendWhoHelped', action.payload.friendId);
                track('tHelperCards', 3, TrackMethod.ADD);
            }
            break;
    }

    return state;
};
